@if (shouldShowRequestBanner) {
  <section [ngClass]="containerClasses">
    <app-request-call-banner
      [experimentVariantData]="currentBannerState.variantData"
      [regimen]="regimen!"
      [regimenClass]="regimen!.class"
      [supportView]="viewMode === 'support'"
      (pendingCallCreated)="onCallCreated()">
    </app-request-call-banner>
  </section>
}

@if (shouldShowStatusBanner) {
  <section [ngClass]="containerClasses">
    @if (isRequestedStatus) {
      <app-call-scheduled-banner [newUI]="currentBannerState.variantData?.newBannerUI" [regimenClass]="regimen?.class"></app-call-scheduled-banner>
    }
    @if (isCallCompletedStatus) {
      <app-call-completed-banner></app-call-completed-banner>
    }
    @if (isUnsuccessfulStatus) {
      <app-doctor-call-unsuccessful-banner [status]="bannerStatus">
      </app-doctor-call-unsuccessful-banner>
    }
  </section>
}

